export default class Item {
  constructor(data) {
    this.pageName = data && data.pageName ? data.pageName : '';
    this.feedback = data && data.feedback ? data.feedback : '';
  }
}

export const feedbackToApiMap = [
  ['pageName', 'pageName'],
  ['feedback', 'feedback'],
];



// WEBPACK FOOTER //
// ./src/models/Feedback.js